import { API_URL } from '../constants/config'
import { query } from './utilities'
import {
  OnContactConsultantSubmission,
  WaitOnContactConsultantSubmission,
} from '../actions/contactUsActions'

export const submitContactConsultantDetails = (
  opportunityId,
  queryDetails,
  dispatch
) => {
  dispatch(WaitOnContactConsultantSubmission())
  query(
    `${API_URL}/opportunity/${opportunityId}/consultant/contact/${global.config.brand}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(queryDetails),
    }
  ).then(
    (data) => {
      dispatch(OnContactConsultantSubmission(true))
    },
    (error) => {
      dispatch(OnContactConsultantSubmission(false))
    }
  )
}
